import HttpClient from '@src/shared/services/base/http-client';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '../utils/market-environment-detection';
export type TSubscribe = (restaurantId: string, deviceToken: string, language: string) => any;

class PushNotificationSubscriptionApiService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public subscribe: TSubscribe = (restaurantId, deviceToken, language) => {
    return this.instance.post('/subscription', {
      restaurantId,
      deviceToken,
      language,
    });
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.NOTIFICATION_SUBSCRIPTION_API_URL_EU_WEST as string;
  }
  return process.env.NOTIFICATION_SUBSCRIPTION_API_URL_EU_CENTRAL as string;
};

export default new PushNotificationSubscriptionApiService(getBaseUrl(), 'X-Auth');
